/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ valueText: NonNullable<unknown> }} Search_Value_KgInputs */

const en_us2_search_value_kg = /** @type {(inputs: Search_Value_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueText}`)
};

const pt_br2_search_value_kg = /** @type {(inputs: Search_Value_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueText}`)
};

const es_419_search_value_kg = /** @type {(inputs: Search_Value_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueText}`)
};

const pt_pt2_search_value_kg = /** @type {(inputs: Search_Value_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueText}`)
};

const fr_fr2_search_value_kg = /** @type {(inputs: Search_Value_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueText}`)
};

const de_de2_search_value_kg = /** @type {(inputs: Search_Value_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueText}`)
};

const it_it2_search_value_kg = /** @type {(inputs: Search_Value_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.valueText}`)
};

/**
* | output |
* | --- |
* | "{valueText}" |
*
* @param {Search_Value_KgInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_value_kg = /** @type {((inputs: Search_Value_KgInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Value_KgInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_value_kg(inputs)
	if (locale === "es-419") return es_419_search_value_kg(inputs)
	if (locale === "pt-PT") return pt_pt2_search_value_kg(inputs)
	if (locale === "fr-FR") return fr_fr2_search_value_kg(inputs)
	if (locale === "de-DE") return de_de2_search_value_kg(inputs)
	if (locale === "it-IT") return it_it2_search_value_kg(inputs)
	return en_us2_search_value_kg(inputs)
});
export { search_value_kg as "search.value_kg" }